import React, { useEffect, useRef, useState } from 'react';
import { Helmet } from 'react-helmet';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import ApplicationLayout from '../../../layouts/ApplicationLayout';
import Loader from '../../../components/ui/Loader/Loader';
import { DisplayListPagination, DisplaySearchCriteria } from '../../../components/TapUi';
import HttpAPICall from '../../../services/HttpAPICall';
import TapIcon from '../../../services/TapIcon';
import { BACKOFFICE_BASE_URL } from '../../../services/TapApiUrls';
import DeviceTypeSearchModal from './DeviceTypeSearchModal';

const DeviceTypeList = ({ history, location }) => {
    const [loading, setLoading] = useState(false);
    const [deviceTypeData, setDeviceTypeData] = useState([]);
    const [listingMeta, setListingMeta] = useState(null);
    const [formSearchedElems, setFormSearchedElems] = useState([]);
    const [searchParams, setSearchParams] = useState({});
    const access_token = useSelector(state => state.auth.access_token);

    const searchModalRef = useRef(null);

    const editManufacturerInit = (item) => {
        history.push({
            pathname: `/device_type_add`,
            state: { editDeviceTypeData: item }
        });
    };
    useEffect(() => {
        getDeviceTypeListing(1);
    }, []);

    const getDeviceTypeListing = (page = 1, searchData) => {

        setLoading(true);

        const params = {
            page: page,
            per_page: 50,
            ...searchData
        };

        HttpAPICall.withAthorization(
            'GET', BACKOFFICE_BASE_URL + '/device_type_list', access_token, params, {}, (resp) => {
                const respData = resp.data;
                setDeviceTypeData(respData.data);
                setListingMeta({
                    'from': respData.from,
                    'to': respData.to,
                    'total': respData.total,
                    'last_page': respData.last_page,
                    'per_page': respData.per_page,
                    'current_page': respData.current_page
                });
            }
        ).then(() => setLoading(false));
    };


    const searchModalHandle = () => {
        if (searchModalRef.current) {
            searchModalRef.current.initModalHandler();
        }
    };

    const submitSearchFormProp = (searchedElems, searchParams) => {
        setFormSearchedElems(searchedElems);
        setSearchParams(searchParams);
        getDeviceTypeListing(1, searchParams);

    };

    const assetMatrixSearchClear = () => {
        setFormSearchedElems([]);
        setSearchParams({});
        if (searchModalRef.current) {
            searchModalRef.current.clearSearchForm();
        }
        getDeviceTypeListing(1);
    };

    const handlePageChange = (page) => {
        getDeviceTypeListing(page, searchParams);
    };

    const deviceTypeListingJsx = () => {
        return (
            <>
                <DisplaySearchCriteria
                    searchedElems={formSearchedElems}
                    onClearFilter={assetMatrixSearchClear}
                />

                <table className="table table-bordered table-fixed bg-white table-sm">
                    <thead className="table-secondary">
                        <tr>
                            <th className='text-center' style={{ width: "10%" }}>S.No.</th>
                            <th className='text-center ms-3' style={{ width: "40%" }}>Name</th>
                            <th className='text-center ms-3' style={{ width: "30%" }}>Is it a child</th>
                            <th className='text-center ms-3' style={{ width: "20%" }}>Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        {loading ? (
                            <tr>
                                <td colSpan={4}>
                                    <Loader />
                                </td>
                            </tr>
                        ) : deviceTypeData.length > 0 ? (
                            deviceTypeData.map((item, index) => (
                                <tr key={item.id || index}>
                                    <td className='text-center'>
                                        {listingMeta ?
                                            (listingMeta.current_page - 1) * listingMeta.per_page + index + 1
                                            : index + 1}
                                    </td>
                                    <td className='text-center'>
                                        {item.name}
                                    </td>
                                    <td className='text-center'>
                                        {Number(item.is_child) === 1 ? 'Yes' : 'No'}
                                    </td>
                                    <td className='text-center'>
                                        <div className="dropdown">
                                            <TapIcon.imageIcon
                                                icon={TapIcon.ListActionIcon}
                                                alt="action-icon"
                                                className="img-fluid px-3"
                                                data-bs-toggle="dropdown"
                                                href="#"
                                                role="button"
                                                aria-expanded="false"
                                            />
                                            <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                                                <li>
                                                    <button
                                                        className="dropdown-item"
                                                        onClick={() => editManufacturerInit(item)}
                                                    >
                                                        Edit
                                                    </button>
                                                </li>
                                            </ul>
                                        </div>
                                    </td>
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td colSpan="4" className="text-center">
                                    No Records Found
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>

                {listingMeta && listingMeta.last_page > 1 && (
                    <DisplayListPagination
                        meta={listingMeta}
                        onPageChange={(e) => handlePageChange(e.selected + 1)}
                    />
                )}
            </>
        );
    };

    const deviceTypeJsx = () => {
        return (
            <>
                <div className="page_title row m0">
                    <div className="col-12">
                        <h3>Device Type</h3>
                        <div className="text-end mt15">
                            <>
                                <Link to="/device_type_add">
                                    <button type="button" className="btn btn-primary">Add</button>
                                </Link>

                                {/* Search Button */}
                                <button
                                    type="button"
                                    className="btn btn-secondary ms-2"
                                    onClick={searchModalHandle}
                                >
                                    <TapIcon.imageIcon
                                        icon={TapIcon.SearchIcon}
                                        className="img-fluid"
                                        alt="search"
                                    />
                                </button>
                            </>
                        </div>
                    </div>
                </div>

                <div className="container-fluid pl5">
                    <div className="page_containt row">
                        <div className='pageTbl col-12'>
                            {deviceTypeListingJsx()}
                        </div>
                    </div>
                </div>

                {/* Search Modal */}
                <DeviceTypeSearchModal
                    ref={searchModalRef}
                    submitSearchFormProp={submitSearchFormProp}
                />
            </>
        );
    };

    return (
        <ApplicationLayout>
            <Helmet>
                <title>Device Type Listing</title>
            </Helmet>
            {deviceTypeJsx()}
        </ApplicationLayout>
    );
};

export default DeviceTypeList;